import UnrealizedProfitLossCellValue from './UnrealizedProfitLossCellValue';

export default UnrealizedProfitLossCellValue;
